import cn from 'classnames';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

const Repeat = ({ className = '' }) => {
  const isTempo = useBrand(TEMPO);
  return (
    <svg
      className={cn('icon', className)}
      aria-hidden="true"
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38 24C38 31.732 31.732 38 24 38C16.268 38 10 31.732 10 24C10 16.268 16.268 10 24 10C31.732 10 38 16.268 38 24Z"
        fill={isTempo ? '#7fc1fb' : '#99CE99'}
      />
      <path
        d="M40.6323 21.4033C41.0441 21.3601 41.4131 21.6594 41.4565 22.0713C41.7316 24.6847 41.4205 27.3268 40.5453 29.8047C39.6701 32.2828 38.2525 34.5345 36.3969 36.3955L36.3959 36.3965C29.5413 43.2508 18.4471 43.2659 11.601 36.4199L9.89984 34.7188L9.90081 40.8496C9.90056 41.2635 9.56479 41.5985 9.15081 41.5986C8.73681 41.5986 8.40107 41.2636 8.40081 40.8496V33.0156C8.40087 32.6064 8.72893 32.2725 9.13812 32.2656L17.1039 32.1328C17.5181 32.1259 17.8597 32.4569 17.8666 32.8711C17.8732 33.2849 17.5432 33.6258 17.1293 33.6328L11.0356 33.7344L12.6616 35.3594C18.9195 41.6173 29.0634 41.6061 35.3344 35.3359C37.0325 33.6329 38.3304 31.5724 39.1313 29.3047C39.932 27.0373 40.217 24.6199 39.9653 22.2285C39.9219 21.8166 40.2204 21.4468 40.6323 21.4033ZM38.8491 6.40137C39.2633 6.40137 39.5991 6.73715 39.5991 7.15137V14.9844C39.599 15.3936 39.2709 15.7275 38.8618 15.7344L30.8959 15.8672C30.4819 15.8741 30.1404 15.5438 30.1332 15.1299C30.1263 14.7158 30.4565 14.3742 30.8705 14.3672L36.894 14.2656L35.3002 12.6719C29.0493 6.42112 18.8967 6.43084 12.6284 12.6992V12.7002C10.9217 14.4028 9.62067 16.4684 8.82269 18.7432C8.02472 21.0182 7.75065 23.445 8.01996 25.8408C8.06595 26.2522 7.76924 26.6236 7.35785 26.6699C6.94631 26.7161 6.57601 26.4194 6.52972 26.0078C6.23524 23.3878 6.53406 20.735 7.40667 18.2471C8.2792 15.7595 9.70261 13.5015 11.5688 11.6396C18.4207 4.78776 29.5218 4.77251 36.3608 11.6113L38.0981 13.3486L38.0991 7.15137C38.0991 6.73721 38.4349 6.40146 38.8491 6.40137Z"
        fill={isTempo ? '#2b2b2b' : '#004400'}
      />
    </svg>
  );
};

Repeat.propTypes = {
  className: PropTypes.string,
};

export default Repeat;
